"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionTypeDefaultForEnterpriseMembers = void 0;
const permissionType_1 = require("./permissionType");
exports.PermissionTypeDefaultForEnterpriseMembers = permissionType_1.PermissionType.edit;
//# sourceMappingURL=enterprisePermissions.js.map